import React, { useEffect, useState } from 'react'
import { CbForgotPasswordModal } from '../CbForgotPassword/CbForgotPasswordModal'
import { useSelector, useDispatch } from 'react-redux'
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction'
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction'
import useStateRef from 'react-usestateref'
import { CheckoutHeader } from './CheckoutHeader'
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction'
import { Modal } from '../Modal/Modal'
import { Organization } from '../CsrSection/Organization'
import { ImpersonateHeader } from '../CsrSection/ImpersonateHeader'
import { CSRHeader } from './CSRHeader'
import Accept from './Accept'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Loader from '../Loader/Loader';
import DesktopHeaderNavContainer from './DesktopHeaderNavContainer'
import MobileHeaderNavContainer from './MobileHeaderNavContainer'
import { useHistory } from 'react-router';
import HubSpotModal from './HubSpotModal';
import SessionTimeout from './SessionTimeout'
import { getLoaderStatusAction } from '../../middleware/getLoaderStatusAction'
import { updateMiniCartDetailsAction } from '../../middleware/updateMiniCartAction'
import { miniCartDetailsAction } from '../../middleware/miniCartDetailsAction'
import { updateMiniCartFlagAction } from '../../middleware/updateMiniCartFlagAction'

function HeaderContainer({containerObject, templateName, contentId, dataZone, isDisableCsrHeaderProp}) {
    const [miniCartDetails, setMiniCartDetails, miniCartDetailsRef] = useStateRef('')
    const [profileDetails, setProfileDetails, profileDetailsRef] = useStateRef('')
    const [miniCartCount, setMiniCartCount, miniCartCountRef] = useStateRef('')
    const [userTypeCheck, setUserTypeCheck, userTypeCheckRef] = useStateRef('')
    const [transient, setTransient, transientRef] = useStateRef('')
    const [mergeState, setMergeState] = useState()
    const [commerceItemDetails, setCommerceItemDetails] = useState()
    const [SessionTimeOut, setSessionTimeOut, sessionTimeOutRef] = useStateRef()
    const [targerter, setTargerter, targerterRef] = useStateRef('')
    const [cookieBannerStatus, setCookieBannerStatus, cookieBannerStatusRef] = useStateRef('');
    const [menuOverlay, setMenuOverlay, menuOverlayRef] = useStateRef(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const updateProfile = useSelector(state => state.updateProfileDetailsReducer)
    const updateMiniCart = useSelector(state => state.updateMiniCartReducer)
    const userId = useSelector(state => state.getOrganizationDetails.userId);
    const showOrganizationHeader = useSelector(state => state.getOrganizationDetails.showOrganizationHeader);
    const miniCartDetailsFromRedux = useSelector(state => state.getMiniCartDetails)
    const location = useLocation();
    const successMsgState = location.state;
    var clickIdUrlParameter = "clickId";
    var clickIdCookieName = "pjn_clicks";
    var lookbackPeriodInDays = "30";
    var cookieDataParsed;
    var maxCookieAge = lookbackPeriodInDays * (60 * 24 * 60);
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const [sessionCount, setSessionCount, sessionCountRef] = useStateRef(0)
    const [loadDom, setloadDom, loadDomRef] = useStateRef(0);
    const [showCookieBanner, setShowCookieBanner, showCookieBannerRef] = useStateRef(false);
    const miniCartUpdateFlag = useSelector(state => state.getUpdateMiniCartFlag);
    let myTimeout;
    const getProfileDetails = () => {
        console.log('getProfileDetails called....');
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/profile-details`, {
            method: 'POST'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    dispatch(getProfileDetailsAction(res.response))
                    setProfileDetailsToRespectiveState(res);
                    let emailIdForSendInBlue = document.getElementById("emailIdForSendInBlue");
                    if (emailIdForSendInBlue && profileDetailsRef.current?.email) {
                        let emailId = emailIdForSendInBlue.getAttribute("value");
                        if (emailId) { } else {
                            emailIdForSendInBlue.setAttribute("value", profileDetailsRef.current?.email);
                        }
                    }
                    if (updateProfile && updateProfile.actionType == "cart" && profileDetailsRef.current && profileDetailsRef.current.userType && profileDetailsRef.current.userType != 3) {
                        handleSendInBlue(res);
                    }
                    dispatch(updateProfileDetailsAction(false, ""))
                }
            })
    }
    const handleRemove$FromPrice = (price) => {
        if (price.includes('$')){
            return price.replace('$', '');
        }
        else{
            return price;
        }
    }

    function triggerTimeOut() {
        let loadingTime = "120000";
        let loaderDelayMessage = "sorry for delay"
        if (document.getElementById("loadingTime")) {
            loadingTime = document.getElementById("loadingTime").getAttribute("value")
        }
        if (document.getElementById("loaderDelayMessage")) {
            loaderDelayMessage = document.getElementById("loaderDelayMessage").getAttribute("value")
        }

        myTimeout = setTimeout(() => {
            handleLoadingDelayMessage(loaderDelayMessage)
        }, parseInt(loadingTime));


    }

    function clearLoadingTimeOut(){
        clearTimeout(myTimeout)
    }

    function handleLoadingDelayMessage(message) {
        console.log("handleLoadingDelayMessage fired");
        dispatch(getLoaderStatusAction(false));
        sample()
    }

    function sample(){
        if (document.getElementById("loaderAlertMessage")) {
            document.getElementById("loaderAlertMessage").innerHTML = message;
            document.getElementById("loaderAlertMessage").classList.remove("d-none");
            document.getElementById("loaderAlertMessage").classList.add("d-block");
        }
    }

    function handleSendInBlue(res) {
        let eventType = "cart_updated"
        let siteUrl = (`${window.location.protocol}//${window.location.hostname}`);
        var properties = {
            "email": profileDetailsRef.current?.email ? profileDetailsRef.current?.email : "",
            "FIRSTNAME": profileDetailsRef.current?.firstName ? profileDetailsRef.current?.firstName : "",
            "LASTNAME": profileDetailsRef.current?.lastName ? profileDetailsRef.current?.lastName : ""
        }
        let cartItems = res?.response?.miniCartDetails?.cartItems && res.response.miniCartDetails.cartItems
        if (cartItems.length < 0) {
            eventType = "cart_deleted"
        }
        let itemsforSib = [];
        cartItems.map((oneItem) => {
            let oneMap = {
                "name": oneItem.displayName,
                "itemnumber": oneItem.productId,
                "price": handleRemove$FromPrice(oneItem.price),
                "quantity": oneItem.quantity,
                "url": siteUrl + oneItem.url,
                "image": siteUrl + oneItem.imgStr
            }
            itemsforSib.push(oneMap)
        })
        let totalAmtSib = res?.response?.miniCartDetails?.subTotal
        let orderId = res?.response?.miniCartDetails?.orderId
        var track_event = {
            "id": orderId,
            "data": {
                "total": handleRemove$FromPrice(totalAmtSib),
                "currency": "USD",
                "url": `${siteUrl}/checkout/cart?sib=true`,
                "items": itemsforSib
            }
        }
        if (window.sendinblue && containerObject?.enableAbandonCartEmail && containerObject?.enableAbandonCartEmail == "true") {

            window.sendinblue.track(eventType, properties, track_event);
        }
    }

    const setProfileDetailsToRespectiveState = (allProfileDetails) => {
        setProfileDetails(allProfileDetails.response && allProfileDetails.response)
        dispatch(getProfileDetailsAction(allProfileDetails.response && allProfileDetails.response))
        setMiniCartDetails(allProfileDetails.response.miniCartDetails && allProfileDetails.response.miniCartDetails)
        setMiniCartCount(allProfileDetails.response.miniCartCount && allProfileDetails.response.miniCartCount)
       setMergeState(allProfileDetails.response.mergeOrderFlag && allProfileDetails.response.mergeOrderFlag)
        setCommerceItemDetails(allProfileDetails.response.commerceItemDetails && allProfileDetails.response.commerceItemDetails)
        setUserTypeCheck(allProfileDetails.response.userTypeCheck && allProfileDetails.response.userTypeCheck)
        setTransient(allProfileDetails.response.transient && allProfileDetails.response.transient)
        //handleGetMiniCartDetails();
        dispatch(miniCartDetailsAction(miniCartDetailsRef.current));
    }
    const handleGetMiniCartDetails = () => {
        console.log(" cart handleGetMiniCartDetails");
        var actionUrl = 'api/rest/cb/profile/mini-cart-details';
        fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                console.log('res...', res && res);
                if (res.status === "success") {
                res?.response?.miniCartDetails && setMiniCartDetails(res.response.miniCartDetails);
                res.response && res.response.miniCartCount && res.response.miniCartCount == 0 ?  setMiniCartCount(res.response.miniCartCount) : setMiniCartCount(res.response.miniCartCount);
                res?.response?.mergeOrderFlag && setMergeState(res.response.mergeOrderFlag);
                 dispatch(miniCartDetailsAction(miniCartDetailsRef.current));
                dispatch(updateMiniCartFlagAction(!miniCartUpdateFlag))
                }else{ 
                    console.log('miniCartDetails error');
                }
            })
            dispatch(updateProfileDetailsAction(false, ""))
            dispatch(updateMiniCartDetailsAction(false,"cart"))

    }

    useEffect(()=>{
        if(containerObject?.disableAjaxCallForCDN == "N"){
            getProfileDetails();
        }else{
            if (containerObject.profileDetails && containerObject.profileDetails.result && containerObject.profileDetails.result === "success") {
                setProfileDetailsToRespectiveState(containerObject.profileDetails);
            }
        }
    },[containerObject?.disableAjaxCallForCDN])

    useEffect(() => {
        
        // console.log('containerObject.miniCartDetails -- ', containerObject.miniCartDetails)
        // if (containerObject.miniCartDetails && containerObject.miniCartDetails.status && containerObject.miniCartDetails.status === "success") {
        //     setMiniCartDetails(containerObject.miniCartDetails.response.miniCartDetails);
        //     setMiniCartCount(containerObject.miniCartDetails.response.miniCartCount)
        //     setMergeState(containerObject.miniCartDetails.response.mergeOrderFlag)
        // }
        if (containerObject && containerObject.targeterResult) {
            setTargerter(containerObject.targeterResult);
        }
        if (containerObject && containerObject.cookieBannerStatus == false || containerObject?.cookieBannerStatus == true) {
            setCookieBannerStatus(containerObject.cookieBannerStatus);
        }
        let search = window.location.search;
        let params = new URLSearchParams(search)
        params = params.toString()
        if (params.includes(clickIdUrlParameter)) {
            checkLookbackPeriod();
            captureClickId();
        }

        handleSendInBlueScript()
        handleBackgroundColor()

    }, [])

    useEffect(() => {
        //console.log('footer loadDomRef.current ----- ', loadDomRef.current)
            if (document.getElementById('cb-footer-cwv') && document.getElementById('cb-footer-cwv').classList.contains("d-none") && loadDomRef.current == 0) {
                const rect = document.getElementById('cb-footer-cwv').getBoundingClientRect();
                const isVisible = (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.getElementById('cb-footer-cwv').documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.getElementById('cb-footer-cwv').documentElement.clientWidth)
                );
                //console.log("footer isVisible code ===", isVisible);
                if (isVisible) {
                    //console.log("footer isVisible true code");
                    setloadDom(1)
                    //console.log('footer loadDomRef.current   12154 ', loadDomRef.current)
                        document.getElementById('cb-footer-cwv').classList.remove("d-none");
                        document.getElementById('cb-footer-cwv').classList.add("d-block");
                    
                }
            }
        //});
    },[containerObject])

    function handleBackgroundColor() {
        let pathName = window.location.pathname;
        if (pathName === '/') {
            let bodyTag = document.getElementById("cbBody");
            if (bodyTag) {
                bodyTag.classList.add("bg-white")
            }
            return;
        }
        if (pathName) {

            let path = pathName.split("/");

            if ((path?.includes("checkout") && !path?.includes("cart") && !path?.includes("confirm") && !path?.includes("order-detail") || path?.includes("voucher"))) {
                let bodyTag = document.getElementById("cbBody");
                if (bodyTag) {
                    bodyTag.classList.add("bg-white")
                }
            } else {
                let bodyTag = document.getElementById("cbBody")
                if (bodyTag) {
                    bodyTag.classList.remove("bg-white")
                }
            }
        }
    }

    function handleSendInBlueScript() {
        const head = document.getElementById("sendInBlueId");
        const script = document.createElement("script");
        let url = "/vaststatic/static-assets/common/resources/js/SendInBlue.js";
        if (url && head) {
            const scriptTags = head.getElementsByTagName('script');
            if (scriptTags) {
                [...scriptTags].forEach(tag => tag.remove());
            }
            script.setAttribute("src", url);
            head.appendChild(script);
        }

    }

    useEffect(() => {
        console.log("cart updateProfile.status",updateProfile.status);
        console.log(" cart updateProfile.actionType",updateProfile.actionType);
        if (updateProfile.status === true && updateProfile.actionType === "login") {
            getProfileDetails();
        }else if(updateProfile.status === true){
            handleGetMiniCartDetails();
        }
    }, [updateProfile.status])

    // useEffect(() => {
    //     if (updateMiniCart.status === true) {
    //         console.log('updateMiniCart status changed..');
    //         handleGetMiniCartDetails();
    //     }
    // }, [updateMiniCart.status])

    useEffect(() => {
        handleSessionTimeOut()
    }, [containerObject])

    useEffect(()=>{
       // window.addEventListener('load', function() {
        //console.log('Page fully loaded!');
        setShowCookieBanner(true);
    //});
},[])



    function handleSessionTimeOut() {
        var cbSessionTimeOut = document.getElementById("cbSessionTimeOut")
        console.log('cbSessionTimeOut...',cbSessionTimeOut);
        if (profileDetailsRef.current) {

            if (profileDetailsRef.current.transient == true) {

            } else {
                if (cbSessionTimeOut) {
                    setSessionTimeOut(cbSessionTimeOut.value * 1000);
                }
                else {
                    setSessionTimeOut(30 * 60 * 1000);
                }

            }

        }

    }

    const handleLogOut = () => {

        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    // updating cart count
                    dispatch(updateProfileDetailsAction(true, "logout"))
                    var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                    dispatch(miniCartItemCountAction(Url))
                    localStorage.clear();
                    parent.location.href = "/account/login?sessionExpired=true";


                } else {
                    const error = res._ERROR_MESSAGE_;
                }
            })
    };


    function handleAlert() {
        setSessionCount(sessionCountRef.current + 1)
        if (sessionCountRef.current == 1) {
            var flag = window.confirm("Your session is going to expire,would you like to continue working?\nClick 'Ok' to continue working or 'Cancel' to logout");

            if (flag) {
                setSessionCount(0)
                setTimeout(handleAlert, sessionTimeOutRef.current)
            } else {

                handleLogOut()
            }
        }
    }

    useEffect(() => {
        document.querySelector('#hubSpotModal').addEventListener('hidden.bs.modal', function (e) {
            document.getElementById('hubSpotIFrame').contentWindow.location.reload();
        })
        document.addEventListener('click', function(event) {
                var element = document.querySelector('a[href="#"]');
                const onclickValue = event.target.getAttribute('onclick');
                if(element && (onclickValue == "javascript:showChat();" || onclickValue == "showChat()")){
                    console.log("element is there...",element);  
                    event.preventDefault();
                }
            });
    }, [])

    function checkLookbackPeriod() {
        var cookieData = getCookieData() || "[]";
        var clickData = [];
        var currDate = new Date(Date.now());
        cookieDataParsed = JSON.parse(cookieData);
        if (cookieDataParsed.length > 0) {
            for (var i = 0; i < cookieDataParsed.length; i++) {
                var dateStr = cookieDataParsed[i].date
                var compDate = new Date(
                    dateStr.substring(0, 4)
                    + "-" + dateStr.substring(4, 6)
                    + "-" + dateStr.substring(6, 8)
                )
                var timeDiff = Math.abs(currDate.getTime() - compDate.getTime());
                var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                if (daysDiff <= lookbackPeriodInDays) {
                    clickData.push(cookieDataParsed[i]);
                }
            }
            document.cookie = clickIdCookieName
                + "="
                + JSON.stringify(clickData)
                + ";max-age=" + maxCookieAge
                + ";path=/";
            cookieDataParsed = clickData;
        }
    }
    function getCookieData() {
        var clickCookie;
        var cookies = document.cookie.split(';');
        cookies.forEach(function (cookie) {
            var parts = cookie.split('=');
            var cookieName = parts[0];
            var cookieValue = parts[1];
            if (cookieName.trim() === clickIdCookieName) {
                clickCookie = cookieValue;
            }
        });
        return clickCookie;
    }

    function getClickId() {
        var clickId = "";
        var queryString = window.location.search.substring(1);
        var queryParams = queryString.split("&");
        for (var i = 0; i < queryParams.length; i++) {
            var data = queryParams[i].split("=");
            if (data[0] === clickIdUrlParameter) {
                clickId = data[1];
            }
        }
        return clickId;
    }
    function captureClickId() {
        var clickId = getClickId();
        if (clickId !== "") {
            var now = new Date(Date.now())
            var date = now.getFullYear()
                + ("0" + (now.getMonth() + 1)).slice(-2)
                + ("0" + now.getDate()).slice(-2)
            var duplicate = false;
            for (var i = 0; i < cookieDataParsed.length; i++) {
                if (clickId === cookieDataParsed[i].id) {
                    duplicate = true;
                    break;
                }
            }
            if (!duplicate) {
                cookieDataParsed.push({
                    'id': clickId,
                    'date': date
                });
                document.cookie = clickIdCookieName
                    + "="
                    + JSON.stringify(cookieDataParsed)
                    + ";max-age=" + maxCookieAge
                    + ";path=/";
            }
        }
    }

    return (
        <>

            {loaderStatus == true ? <Loader></Loader> : ""}
            <p className='m-0' id="triggerLoader" onClick={()=>triggerTimeOut()}></p>
            <p className='m-0' id="cancelLoader" onClick={()=>clearLoadingTimeOut()}></p>
            <HubSpotModal />
            {sessionTimeOutRef.current ? <SessionTimeout timeOut={sessionTimeOutRef.current} /> : ""}
            <Modal newListModalId="newListModal" />
            <div id="printed">
                <img fetchpriority="high" src="/images/carolina-print.jpg" style={{ "display": "none" }} />
            </div>
            {/* {sessionTimeOutRef.current ? 
          <SessionTimeout timeout={sessionTimeOutRef.current}/>:""}*/}
            {/* CSR Header */}
            {!transientRef.current && userTypeCheckRef.current && userTypeCheckRef.current.user == "csr" &&
                <div id="csr_head">
                    <div className="c-container bg-light-grey csr-header">
                        <div className="row align-items-center mt-3">
                            {showOrganizationHeader ?
                                <Organization />
                                :
                                <CSRHeader />
                            }
                        </div>
                    </div>
                </div>
            }
            {!transientRef.current && userTypeCheckRef.current && userTypeCheckRef.current.user == "imperson" &&
                <ImpersonateHeader userId={userId} />
            }
            {containerObject.attributes && containerObject.attributes.isCheckOutPage && containerObject.attributes.isCheckOutPage == "Y" ?
                <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row gx-0 header-padding-row cb-checkout-header`} >
                    <header className='d-block'>
                        <CheckoutHeader profile={profileDetailsRef.current} targerter={targerterRef.current} headerLogo={containerObject.attributes && containerObject.attributes.headerLogo} />
                    </header>
                </div> :
                <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row gx-0`} >
                    <header className='d-lg-block d-none'>
                        <DesktopHeaderNavContainer
                            searchQuery={containerObject && containerObject.searchedValue ? containerObject.searchedValue : ""}
                            navMenu={containerObject && containerObject.navMenu ? containerObject.navMenu : ""}
                            tileMenu={containerObject && containerObject.tileMenu ? containerObject.tileMenu : ""}
                            topRibbenMenu={containerObject && containerObject.topRibbenMenu ? containerObject.topRibbenMenu : ""}
                            profile={profileDetailsRef.current} miniCartItemsCount={miniCartCountRef.current}
                            miniCartItems={miniCartDetailsRef.current}
                            successMsgState={successMsgState}
                            targerter={targerterRef.current}
                            productSearchPageUrl={containerObject && containerObject.productSearchPageUrl ? containerObject.productSearchPageUrl : ""}
                            contentSearchPageUrl={containerObject && containerObject.contentSearchPageurl ? containerObject.contentSearchPageurl : ""}
                            isPunchout={containerObject.isPunchout}
                            headerLogo={containerObject && containerObject.headerLogo}
                            containerAttr={containerObject && containerObject.attributes ? containerObject.attributes : ""}
                        />
                    </header>
                    <header className='d-lg-none d-block cb-header-mobile'>
                        <MobileHeaderNavContainer
                            navMenu={containerObject && containerObject.navMenu ? containerObject.navMenu : ""}
                            profile={profileDetailsRef.current}
                            miniCartItemsCount={miniCartCountRef.current} miniCartItems={miniCartDetailsRef.current}
                            targerter={targerterRef.current}
                            searchQuery={containerObject && containerObject.searchedValue ? containerObject.searchedValue : ""}
                            productSearchPageUrl={containerObject && containerObject.productSearchPageUrl ? containerObject.productSearchPageUrl : ""}
                            contentSearchPageUrl={containerObject && containerObject.contentSearchPageurl ? containerObject.contentSearchPageurl : ""}
                            setMenuOverlay={setMenuOverlay}
                            headerLogo={containerObject && containerObject.headerLogo}
                            tileMenu={containerObject && containerObject.tileMenu ? containerObject.tileMenu : ""}
                            topRibbenMenu={containerObject && containerObject.topRibbenMenu ? containerObject.topRibbenMenu : ""}
                        />
                    </header>

                </div>
            }
            <CbForgotPasswordModal />
            <div id="loaderAlertMessage" className='alert alert-danger mt-3 d-none'></div>

            {containerObject.cookieBannerStatus == false && showCookieBannerRef.current? <Accept /> : <></>}
        </>
    )
}

export default HeaderContainer
